import React from "react";
import ReactDOM from "react-dom";
import {
  Section,
  Image,
  Headline,
  Paragraph,
  Box,
  Heading,
  Video
} from "grommet";

import screenshot from "./screenshot.jpg";
import video from "./video.mp4";

const GazooRacing = props => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        Toyota Japan Gazoo Racing Configurator
      </Heading>
    ) : null}
    <Box direction="row" size={{ width: "xxlarge" }}>
      <Box
        direction="column"
        basis="2/3"
        margin="small"
        textAlign="left"
        align="center"
      >
        <Video
          size="large"
          autoPlay={true}
          loop={true}
          showControls={false}
          allowFullScreen={false}
        >
          <source src={video} type="video/mp4" />
        </Video>

        <Paragraph>
          This is a WebGL virtual showroom I was involved with at Rotor for
          Toyota Japan. The user can select from 10 different vehicles in the
          Gazoo Racing line and configure them in their browser. It's built with
          Blend4Web as a rendering engine and React for the ui. Blend4Web is a
          product which allows blender scenes to be exported into a WebGL
          bundle. It's designed to work on desktop and mobile.
        </Paragraph>
        <Paragraph>
          A big challenge in this project was to optimise the assets for the
          web. Since we got each vehicle in raw CAD form they could be as large
          as 100GB. We managed to reduce the vehicle sizes to around 15-25MB
          when gzipped. Unfortunately we weren't able to use Draco compression,
          which would have provided much better compression, since Blend4Web
          didn't support it. We had a lot of issues with Blend4Web and often had
          to build workarounds for its nuances and missing features. We've moved
          to ThreeJS instead for our current and future projects.
        </Paragraph>
        <Paragraph>
          My responsibilties were to oversee the technical architecture and
          design of the project, create the project structure and build tools,
          work with 3D artists and front end developers to ensure a smooth
          development process and developing the 3D WebGL features of the
          experience.
        </Paragraph>
      </Box>
      <Box direction="column" basis="1/3" justify="left" textAlign="left">
        <Paragraph>
          This project was my first deep dive into modern Javascript and its
          ecosystem like Webpack, React, Babel and NodeJS. I never used to pay
          javascript much attention but now I've become very fond of it. It was
          a fun project to work on and in the end I think it looked pretty good!
          It's a shame we couldn't reduce the load time any more, our new
          projects using ThreeJS and draco have been a big improvement in this
          aspect.
        </Paragraph>
        <Image src={screenshot} size="medium" />
        <Paragraph size="small">
          To try it click here:{" "}
          <a href="https://toyotagazooracing.com/jp/gr/config">
            https://toyotagazooracing.com/jp/gr/config
          </a>
        </Paragraph>
      </Box>
    </Box>
  </Section>
);

export default GazooRacing;



// WEBPACK FOOTER //
// ./src/components/projects/gazoo-racing/gazoo-racing.js